var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile shadow",on:{"click":_vm.tileClicked}},[_c('div',{staticClass:"top p-3"},[_vm._t("image")],2),_c('div',{staticClass:"bottom m-3"},[_c('div',{staticClass:"line"},[_c('strong',[_vm._t("line1")],2)]),_c('div',{staticClass:"line"},[_vm._t("line2")],2),_c('div',{staticClass:"line"},[_vm._t("line3")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }